import { defineCopy } from "../intl";

import { FORMAT_LIMIT_COPY_EN_US } from "./en-us/format-limit.copy";
import { FORMAT_LIMIT_COPY_ES_ES } from "./es-es/format-limit.copy";

/** Rótulos e sufixos de `formatLimit`. */
export const FORMAT_LIMIT_COPY_PT_BR = {
  /** Feature desligada fora do teste. */
  disabled: "—",
  /** Gate puro ligado, ou janela de teste sem prazo: sem número para mostrar. */
  included: "incluso",
  unlimited: "ilimitado",
  trialOnly: "no teste",
  trialWithLimit: (limit: number) => `${limit} no teste`,
  hours: (stored: number) => `${stored}h`,
  hoursAsDays: (days: number) => `${days} dias`,
  days: (stored: number) => `${stored} dias`,
  trialDay: "1 dia",
  trialDays: (stored: number) => `${stored} dias`,
  interval: (value: string) => `a cada ${value}`,
  monthly: (counted: string) => `${counted} /mês`,
  total: (counted: string) => `${counted} no total`,
} as const;

export const FORMAT_LIMIT_COPY = defineCopy(FORMAT_LIMIT_COPY_PT_BR, {
  "en-US": FORMAT_LIMIT_COPY_EN_US,
  "es-ES": FORMAT_LIMIT_COPY_ES_ES,
});
